import styled from 'styled-components/macro'

export default styled.svg`
  animation: rotate 2s linear infinite;
  z-index: 1;
  margin: ${props => !props.isButton && "20px"} auto;
  width: 46px;
  background-color: transparent;

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
  position: ${props => props.isButton && "absolute"};
  top: 0;
  left: ${props => props.theme.left};
`

export const Path = styled.circle`
  stroke: rgba(${props => props.isButton ? '255, 255, 255, 0.8' : '255, 87, 34, 0.9'});
  stroke-linecap: round;
  animation: dash 1.5s ease-in-out infinite;

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
      }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  };
`
